import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { RootState } from '../../../../../../reducers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../store/store';
import { setRequestType } from '../../../../../../store/requestReport.slice';
import { fetchRequestTypeOptions } from '../../../../../../store/requests.slice';

const RequestTypeAutocomplete = () => {
    const dispatch = useAppDispatch();
    const [requestTypeInputValue, setRequestTypeInputValue] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [data, setData] = useState<{ value: string; label: string }[]>([]);
    const { requestType } = useSelector((state: RootState) => state.requestReport);

    useEffect(() => {
        let isMounted = true;

        const loadRequestTypes = async () => {
            try {
                setIsLoading(true);
                setIsError(false);
                setError(null);
                const result = await fetchRequestTypeOptions();
                if (isMounted) {
                    setData(result);
                    setIsLoading(false);
                }
            } catch (err) {
                if (isMounted) {
                    setIsError(true);
                    setError(err as Error);
                    setIsLoading(false);
                }
            }
        };

        loadRequestTypes();

        return () => {
            isMounted = false;
        };
    }, []);

    let requestTypeAutocomplete: React.ReactNode = null;
    if (isLoading) {
        requestTypeAutocomplete = (
            <Box style={{ textAlign: 'center' }}>
                <CircularProgress />
            </Box>
        );
    } else if (isError) {
        requestTypeAutocomplete = <p>Error: {error?.message}</p>;
    } else {
        requestTypeAutocomplete = (
            <Autocomplete
                size="small"
                fullWidth
                multiple={false}
                id="request-type-selection"
                options={[{ label: 'All', value: 'All' }, ...data]} // Add All at top
                value={(data || []).find((d) => d.value === requestType) || { label: 'All', value: 'All' }} // Default to All
                isOptionEqualToValue={(option, value: any) => {
                    return option.value === value.value;
                }}
                renderInput={(params) => <TextField {...params} label="Request Type" />}
                onChange={(event: any, newValue: any) => {
                    console.log({ event, newValue });
                    if (newValue?.value) {
                        dispatch(setRequestType(newValue.value));
                    } else {
                        dispatch(setRequestType(newValue?.value ?? null));
                    }
                }}
                getOptionLabel={(option: any) => option.label}
                inputValue={requestTypeInputValue}
                onInputChange={(event, value) => {
                    setRequestTypeInputValue(value);
                }}
            />
        );
    }

    return requestTypeAutocomplete;
};

export default React.memo(RequestTypeAutocomplete);
